var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"LandingLandowners"}},[(_vm.isItalianEnglishSpanish)?_c('ContentItalianEnglishSpanish'):_vm._e(),(_vm.isLithuanian)?_c('ContentLithuanian'):_vm._e(),(_vm.isPolish)?_c('ContentPolish'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }